import { FC } from "react";
import { Stack } from "@mui/material";
import TextIconButton from "@components/TextIconButton";
import { useTranslation } from "react-i18next";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import NotificationsOffOutlinedIcon from "@mui/icons-material/NotificationsOffOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { useMediaQuery } from "react-responsive";
import { ScreenSize } from "@constants/screen-size";

const ScheduleToolbar: FC<{
  checkedEnabled: number;
  checkedDisabled: number;
  onDelete: () => void;
  onEnable: () => void;
  onDisable: () => void;
  onCreate: () => void;
}> = ({
  checkedEnabled,
  checkedDisabled,
  onDelete,
  onEnable,
  onDisable,
  onCreate,
}) => {
  const { t } = useTranslation();
  const isSmScreen = useMediaQuery({
    query: `(max-width: ${ScreenSize.md}px)`,
  });

  return (
    <Stack
      flexDirection="row"
      justifyContent="space-between"
      gap="16px"
      flexWrap="wrap"
    >
      <Stack flexDirection="row" gap="16px">
        <TextIconButton
          disabled={!checkedEnabled && !checkedDisabled}
          onClick={onDelete}
          variant="outlined"
          color="error"
          text={isSmScreen ? "" : t("schedule.toolbar.deleteButton")}
          icon={DeleteOutlineOutlinedIcon}
        />
        <TextIconButton
          disabled={!checkedEnabled}
          onClick={onDisable}
          variant="outlined"
          text={isSmScreen ? "" : t("schedule.toolbar.disableButton")}
          icon={NotificationsOffOutlinedIcon}
        />
        <TextIconButton
          disabled={!checkedDisabled}
          onClick={onEnable}
          variant="outlined"
          text={isSmScreen ? "" : t("schedule.toolbar.enableButton")}
          icon={NotificationsOutlinedIcon}
        />
      </Stack>

      <TextIconButton
        onClick={onCreate}
        variant="outlined"
        text={isSmScreen ? "" : t("schedule.toolbar.createButton")}
        icon={AddOutlinedIcon}
      />
    </Stack>
  );
};

export default ScheduleToolbar;
